module.exports = __webpack_public_path__ + "static/ravish-raj-171288ad905589e2bd0c747f76fe2dfe.jpg";